// Dependency-free so both UserPreferencesService and axiosInstance can import it without a cycle
// (service → userPreferenceAPI → axiosInstance).

/** Session-scoped grid filter state (PR-797) — must be cleared on every sign-out path. */
export const SESSION_GRIDS_KEY = 'sessionGridState';
